import type { UiLang, TripForm } from "./types";
import { formToQuery } from "./url";

/**
 * Åpner reiseplanen i brukerens kalenderapp.
 *
 * Tidligere lastet dette ned en .ics-fil fra en blob-URL. På telefonen er det
 * feil svar: filen havner i nedlastingsmappa, og på iPhone skjer det ofte
 * ingenting i det hele tatt. Det man vil er at Kalender åpner seg med turen
 * klar til å legges inn.
 *
 * `webcal://` er skjemaet som gjør nettopp det, og det krever en ekte URL —
 * derfor genereres filen på serveren, fra de samme parameterne som
 * delelenken bruker. Apple-plattformene forstår `webcal://` og åpner
 * Kalender direkte. Android og Windows gjør det ikke pålitelig, så de får
 * vanlig https, der nettleseren gir filen videre til kalenderappen.
 */
function opensWebcal(): boolean {
  const ua = navigator.userAgent;
  // iPadOS oppgir seg som Mac, så berøringsstøtte skiller dem ikke — men
  // begge håndterer webcal, så det spiller ingen rolle her.
  return /iPhone|iPad|iPod|Macintosh/.test(ua);
}

export function openInCalendar(form: TripForm, lang: UiLang): void {
  const query = formToQuery(form, lang).replace(/^\?/, "");
  const path = `/api/calendar?${query}`;

  if (opensWebcal()) {
    // webcal:// erstatter https:// og peker på samme sted.
    window.location.href = `webcal://${window.location.host}${path}`;
    return;
  }

  window.location.href = path;
}
